export default __webpack_public_path__ + "static/media/chillingbreath.115785f9.png";